class SplitTunneling {
    constructor(splitTunnelingBlacklist, initAll = true) {
        this.organizationID = new URLSearchParams(window.location.search).get('organizationID');
        this.splitTunnelingBlacklist = splitTunnelingBlacklist;
        this.includeMembersSplitTunnelingValidation = null;

        new CustomSplitTunnelingDatatable();
        new IncludeMembersSplitTunnelingDatatable(this);

        this.splitTunnelingCheckbox();
        this.addCustomSplitTunnelingFormValidation();
        this.includeMembersSplitTunnelingFormValidation();
    }
    splitTunnelingCheckbox(){
        let thisClass = this;
        let checkbox = document.getElementById('splitTunnelingEnabledCheckbox');
        if(checkbox){
            checkbox.addEventListener('change', (event) => {
                event.preventDefault();
                if (event.currentTarget.disabled === false) {
                    let swalText;
                    let checked = event.currentTarget.checked;
                    if (!checked) {
                        swalText = 'Are you sure you want to <b>disable</b> Split Tunneling?';
                    } else {
                        swalText = 'Are you sure you want to <b>enable</b> Split Tunneling?';
                    }
                    Swal.fire({
                        html: `<span class="text-center text-primary">${swalText}</span>`,
                        icon: "warning",
                        iconColor: "#FF5206",
                        buttonsStyling: false,
                        reverseButtons: true,
                        showCancelButton: true,
                        confirmButtonText: "Save changes",
                        customClass: {
                            confirmButton: "btn btn-danger mt-0",
                            cancelButton: 'btn btn-light-primary mt-0',
                        },
                        showLoaderOnConfirm: true,
                        returnFocus: false,
                        preConfirm: () => {
                            return fetch('/split-tunneling?do=changeSplitTunnelingValue&organizationID='+thisClass.organizationID+'&result='+(checked ? 1 : 0))
                                .then(response => {
                                    if (!response.ok) {
                                        throw new Error(response.statusText)
                                    }
                                    return response.json();
                                }).catch(error => {
                                    Swal.showValidationMessage(`Request failed: ${error}`)
                                });
                        },
                        allowOutsideClick: () => !Swal.isLoading(),
                        allowEscapeKey: () => !Swal.isLoading()
                    }).then((result) => {
                        if (result.isConfirmed) {
                            if(result.value === true){
                                let badge = document.getElementById('split-tunneling-status-badge');
                                if(checked){
                                    badge.classList.remove('badge-danger');
                                    badge.classList.add('badge-success');
                                    badge.innerText = 'Active';
                                    toastr.success('Split Tunneling has been successfully enabled!');
                                } else {
                                    badge.classList.remove('badge-success');
                                    badge.classList.add('badge-danger');
                                    badge.innerText = 'Inactive';
                                    toastr.success('Split Tunneling has been successfully disabled!');
                                }
                            }
                        } else {
                            checkbox.checked = !checked;
                        }
                    });
                }
            });
        }
    }
    initTagifyAddCustomSplitTunneling(){
        const thisClass = this;
        const domainOrIpInput = document.querySelector('#frm-addCustomSplitTunnelingForm-addCustomSplitTunnelingForm input[name=DomainOrIp]');
        if(domainOrIpInput){
            let tagify = new Tagify(domainOrIpInput, {
                pattern: /^(?!0\.0\.0\.0\/(0|1)$)(?!128\.0\.0\.0\/1$)((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?))(\/([0-9]|[1-2][0-9]|3[0-2]))?$|^([-A-Za-z0-9]+(?:\.[-A-Za-z0-9]+){1,14})$/,
                keepInvalidTags: true,
                blacklist: thisClass.splitTunnelingBlacklist,
                editTags: 0,
                delimiters: ",|;| ,| |:|[\\n\\r]",
                maxTags: 20,
                texts: {
                    pattern: "Invalid Domain/IP format"
                }
            });
            new SpacebarEvent(tagify);

            const onAddTag = async ({detail: {data, tag}}) => {
                tagify.tagLoading(tag, true);
                const validResponse = await getIfDomainIsValid(data.value);
                tagify.tagLoading(tag, false);

                if( !validResponse.valid )
                    tagify.replaceTag(tag, {...data, __isValid: validResponse.message});
            }

            const getIfDomainIsValid = async (value) => {
                return await fetch(`/split-tunneling/?do=getIfDomainIsValid&organizationID=${thisClass.organizationID}&value=${value}`)
                    .then(response => {
                        if (!response.ok) {
                            throw new Error(response.statusText)
                        }
                        return response.json();
                    });
            }

            tagify.on('add', onAddTag);

            return tagify;
        }
    }
    addCustomSplitTunnelingFormValidation(){
        const thisClass = this;
        let form = document.getElementById('frm-addCustomSplitTunnelingForm-addCustomSplitTunnelingForm');
        let tagify;
        if(form){
            if(form.querySelector('input[name=DomainOrIp]')){
                tagify = this.initTagifyAddCustomSplitTunneling();
            }
            let submitButton = document.getElementById('add_custom_split_tunneling_form_submit');

            let validator = FormValidation.formValidation(
                form,
                {
                    fields: {
                        'DomainOrIp': {
                            validators: {
                                notEmpty: {
                                    message: 'This field is required'
                                }
                            },
                        },
                    },
                    plugins: {
                        trigger: new FormValidation.plugins.Trigger(),
                        autoFocus: new FormValidation.plugins.AutoFocus(),
                        submitButton: new FormValidation.plugins.SubmitButton(),
                        // defaultSubmit: new FormValidation.plugins.DefaultSubmit(), // Uncomment this line to enable normal button submit after form validation
                        bootstrap: new FormValidation.plugins.Bootstrap5({
                            rowSelector: '.fv-row',
                            eleInvalidClass: '',
                            eleValidClass: ''
                        }),
                    }
                }
            );

            const waitForTagsToLoad = () => {
                return new Promise(resolve => {
                    function checkTags() {
                        let tagsElms = tagify ? tagify.getTagElms() : null;
                        if (tagsElms) {
                            let hasLoadingTag = tagsElms.some(tag => tag.classList.contains('tagify__tag--loading'));
                            if (hasLoadingTag) {
                                setTimeout(checkTags, 100);
                            } else {
                                resolve();
                            }
                        } else {
                            resolve();
                        }
                    }
                    checkTags();
                });
            }


            submitButton.addEventListener('click', function (e) {
                // Prevent default button action
                e.preventDefault();
                // Show loading indication
                submitButton.setAttribute('data-kt-indicator', 'on');
                // Disable button to avoid multiple click
                submitButton.disabled = true;
                waitForTagsToLoad().then(() => {
                    validator.validate().then(function(status) {
                        if(status === 'Valid'){
                            new DismissModal('add_custom_split_tunneling_modal').disable();
                            $('#frm-addCustomSplitTunnelingForm-addCustomSplitTunnelingForm').submit();
                        } else {
                            // Show loading indication
                            submitButton.setAttribute('data-kt-indicator', 'off');
                            // Disable button to avoid multiple click
                            submitButton.disabled = false;
                        }
                    });
                });
            });

            $.nette.ext('addCustomSplitTunnelingForm', {
                success: function (payload, status, jqXHR, settings) {
                    let formID = settings.nette.form[0].attributes.id.value;
                    if(formID === 'frm-addCustomSplitTunnelingForm-addCustomSplitTunnelingForm'){
                        if(payload){
                            toastr.success('Domain has been successfully created!');
                        } else {
                            toastr.error('This domain has been already created or you have exceeded the limit!');
                        }
                        
                        new DismissModal('add_custom_split_tunneling_modal').enable();
                        bootstrap.Modal.getInstance(document.getElementById('add_custom_split_tunneling_modal')).hide();

                        $('#custom-split-tunneling-datatable').DataTable().draw();

                        let form = $('#frm-addCustomSplitTunnelingForm-addCustomSplitTunnelingForm');
                        form.find('input[name=DomainOrIp]').val('');

                        // Cancel loading indication
                        submitButton.setAttribute('data-kt-indicator', 'off');
                        submitButton.disabled = false;
                    }
                }
            });
        }
    }
    initAddMembersOrGroupTagify(){
        const thisClass = this;
        $.ajax({
            url: '?do=getAllMembersAndGroups',
            type: 'GET',
            dataType: '',
            data: {
                organizationID: thisClass.organizationID
            }
        }).done(function(data) {
            const membersOrGroupsToAdd = document.querySelector('#add_include_members_split_tunneling_modal input[name=membersOrGroupsToAdd]');
            const addAllMembersCheckbox = document.querySelector('#add_include_members_split_tunneling_modal input[name="addAllMembers"]');

            let tagifyData = data['data'];
            /** Adding values - tagify needs 'value' */
            for(let i in tagifyData){
                tagifyData[i]['value'] = tagifyData[i]['uuid'];
            }

            if(data['allMembers']){
                membersOrGroupsToAdd.value = '';
                membersOrGroupsToAdd.disabled = true;
                addAllMembersCheckbox.checked = true;
            } else {
                membersOrGroupsToAdd.disabled = false;
                addAllMembersCheckbox.checked = false;

                /** Destroy tagify on input - we want new instance if tagify already exist */
                if(membersOrGroupsToAdd.__tagify){
                    membersOrGroupsToAdd.__tagify.destroy();
                }

                /** Initialize tagify input for adding members or groups */
                new MembersGroupsTagify(membersOrGroupsToAdd, tagifyData);
                membersOrGroupsToAdd.__tagify.on('change', revalidateAddAllMembers);
            }

            /** On add all members checkbox change -> destroy or create tagify */
            addAllMembersCheckbox.addEventListener('click', function () {
                if(addAllMembersCheckbox.checked){
                    membersOrGroupsToAdd.value = '';
                    if(membersOrGroupsToAdd.__tagify){
                        membersOrGroupsToAdd.__tagify.destroy();
                    }
                    membersOrGroupsToAdd.disabled = true;
                } else {
                    membersOrGroupsToAdd.disabled = false;
                    new MembersGroupsTagify(membersOrGroupsToAdd, tagifyData);
                    membersOrGroupsToAdd.__tagify.on('change', revalidateAddAllMembers);
                }
            });

            function revalidateAddAllMembers() {
                thisClass.includeMembersSplitTunnelingValidation.revalidateField('addAllMembers');
            }
        });
    }
    includeMembersSplitTunnelingFormValidation(){
        let thisClass = this;
        let form = document.getElementById('frm-includeMembersSplitTunnelingForm-includeMembersSplitTunnelingForm');
        if(form){
            if(form.querySelector('input[name=membersOrGroupsToAdd]')){
                this.initAddMembersOrGroupTagify();
            }
            let submitButton = document.getElementById('add_include_members_split_tunneling_modal_submit');

            let validator = FormValidation.formValidation(
                form,
                {
                    fields: {
                        'addAllMembers': {
                            validators: {
                                callback: {
                                    message: 'Add at least one Member/Group or check "Add all Members"',
                                    callback: function (input) {
                                        let value = $('#frm-includeMembersSplitTunnelingForm-includeMembersSplitTunnelingForm input[name="membersOrGroupsToAdd"]').val();
                                        let numberOfMembersAndGroups = value ? JSON.parse(value.val()).length : 0;
                                        let addAllMembers = form.querySelector('input[name="addAllMembers"]').checked;

                                        return addAllMembers || numberOfMembersAndGroups;
                                    },
                                },
                            },
                        },
                    },
                    plugins: {
                        trigger: new FormValidation.plugins.Trigger(),
                        autoFocus: new FormValidation.plugins.AutoFocus(),
                        submitButton: new FormValidation.plugins.SubmitButton(),
                        // defaultSubmit: new FormValidation.plugins.DefaultSubmit(), // Uncomment this line to enable normal button submit after form validation
                        bootstrap: new FormValidation.plugins.Bootstrap5({
                            rowSelector: '.fv-row',
                            eleInvalidClass: '',
                            eleValidClass: ''
                        }),
                    }
                }
            );
            this.includeMembersSplitTunnelingValidation = validator;

            submitButton.addEventListener('click', function (e) {
                // Prevent default button action
                e.preventDefault();
                validator.validate().then(function(status) {
                    if(status === 'Valid'){
                        new DismissModal('add_include_members_split_tunneling_modal').disable();
                        // Show loading indication
                        submitButton.setAttribute('data-kt-indicator', 'on');
                        // Disable button to avoid multiple click
                        submitButton.disabled = true;
                        $('#frm-includeMembersSplitTunnelingForm-includeMembersSplitTunnelingForm').submit();
                    }
                });
            });

            $.nette.ext('addIncludeMembersSplitTunnelingForm', {
                success: function (payload, status, jqXHR, settings) {
                    let formID = settings.nette.form[0].attributes.id.value;
                    if(formID === 'frm-includeMembersSplitTunnelingForm-includeMembersSplitTunnelingForm'){
                        if(payload){
                            $('#customSplitTunnelingMembers_wrapper [data-kt-docs-table-filter=search]').parent().show();
                            $('#include-members-split-tunneling-datatable_wrapper').show();
                            toastr.success('Members/Groups have been successfully added!');
                        } else {
                            toastr.error('Unexpected error occurred. Please try it again later or contact our support team.');
                        }

                        new DismissModal('add_include_members_split_tunneling_modal').enable();
                        bootstrap.Modal.getInstance(document.getElementById('add_include_members_split_tunneling_modal')).hide();

                        let includeMembersSplitTunnelingDatatable = $('#include-members-split-tunneling-datatable');
                        includeMembersSplitTunnelingDatatable.DataTable().clearPipeline();
                        includeMembersSplitTunnelingDatatable.DataTable().ajax.reload();

                        thisClass.initAddMembersOrGroupTagify();

                        let form = $('#frm-includeMembersSplitTunnelingForm-includeMembersSplitTunnelingForm');
                        form.find('input[name=membersOrGroupsToAdd]').val('');

                        // Cancel loading indication
                        submitButton.setAttribute('data-kt-indicator', 'off');
                        submitButton.disabled = false;
                    }
                }
            });
        }
    }
}
window.SplitTunneling = SplitTunneling;